/**
 * @module Components.StripeForm
 *
 */
import React from "react";
import AcademyCheckoutFormWrapper, {
  PropsDef,
} from "./AcademyCheckoutFormWrapper";

export default function StripeForm(props: PropsDef) {
  return <AcademyCheckoutFormWrapper {...props} />;
}
